import { apiAxios } from "../apiConfig";

// VOLUNTEER FORM SUBMIT API
export const submitVolunteerApplication = async (payload) => {
  try {
    const response = await apiAxios.post("/volunteers", payload);
    return response.data;
  } catch (error) {
    console.error("Volunteer application submit error:", error);
    throw error;
  }
};
